'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {ViewMode, ViewModePropType} from '../../../core-utilities/enums/ViewMode';


export function CommentIndicatorView(props) {
  const mode = props.mode || ViewMode.LOADING;
  const title = props.title || props.defaultChatTitle;
  return (
    <div
      className={classNames('CommentIndicator', props.className)}
      title={title || 'Chat'}
      onClick={props.onClick}
    >
      <div className="CommentIndicator__block">
        <div
          className={classNames('CommentIndicator__icon', {
            'CommentIndicator__icon_loading': mode === ViewMode.LOADING,
            'CommentIndicator__icon_error': mode === ViewMode.EOTHER || mode === ViewMode.ENONET,
            'CommentIndicator__icon_empty': mode === ViewMode.SUCCESS && !props.hasComments,
            'CommentIndicator__icon_full': mode === ViewMode.SUCCESS && props.hasComments,
          })}
        />
        {props.hasUnread || props.pulseUnread ? (
          <div
            className={classNames('CommentIndicator__dot', {
              'CommentIndicator__dot_show': props.hasUnread,
              'CommentIndicator__dot_pulse': props.pulseUnread,
            })}
          />
        ) : null}
      </div>
      {title && props.displayTitle ? (
        <span className={classNames("CommentIndicator__title", props.titleClassName)}>
          {title}
        </span>
      ) : null}
    </div>
  );
}

CommentIndicatorView.propTypes = {
  className: T.string,
  titleClassName: T.string,
  title: T.string,
  defaultChatTitle: T.string,
  displayTitle: T.bool,
  onClick: T.func,
  mode: ViewModePropType,
  hasComments: T.bool,
  hasUnread: T.bool,
  pulseUnread: T.bool,
};

CommentIndicatorView.messages = [
  {code: 'icon.chat.title', prop: 'defaultChatTitle'},
];

CommentIndicatorView.messageProps = [
  'defaultChatTitle',
];



// WEBPACK FOOTER //
// ./src/js/comments/components/CommentIndicator/CommentIndicatorView.js